// src/utils/filenameUtils.js
// 26.11.25 AEST - Utility to clean up display filenames
// Handles multiple patterns:
// Pattern A: [hash]_[timestamp]_[filename] (e.g., 19ab45990ac9a335_1763962387122_test.txt)
// Pattern B: [timestamp]_[filename] (e.g., 1763956682197_NDIS Plan.pdf)

export const cleanFilename = (filename) => {
  if (!filename) return 'Untitled';
  
  const parts = filename.split('_');
  
  if (parts.length >= 3) {
    const possibleHash = parts[0];
    const possibleTimestamp = parts[1];
    
    // Pattern A: hash_timestamp_filename
    const isHash = /^[a-f0-9]{16,}$/i.test(possibleHash);
    const isTimestamp = /^\d{13}$/.test(possibleTimestamp);
    
    if (isHash && isTimestamp) {
      return parts.slice(2).join('_');
    }
  }
  
  if (parts.length >= 2) {
    const possibleTimestamp = parts[0];
    
    // Pattern B: timestamp_filename (timestamp is 13 digits)
    const isTimestamp = /^\d{13}$/.test(possibleTimestamp);
    
    if (isTimestamp) {
      return parts.slice(1).join('_');
    }
  }
  
  // Return original if no pattern matches
  return filename;
};